/**
 * CCS Admin Theme — Minimal UI Kit + CCS Brand Palette
 *
 * This file is the single theme entry-point for all 3 admin portals.
 * It injects the CCS brand palette into the Minimal free kit's base theme
 * (typography, shadows, shape, component overrides) without touching any
 * other Minimal token.
 *
 * To upgrade to the paid Minimal Dashboard:
 *   1. Replace the `createMinimalTheme` import with the paid kit's equivalent.
 *   2. Keep `CSS_PALETTE` and `createAdminTheme` unchanged — they sit on top.
 *   See THEME_MIGRATION.md for the full upgrade guide.
 */

import type { Theme } from "@mui/material/styles";
import { createMinimalTheme } from "./minimal-theme";

export const CCS_PALETTE = {
  katanaPurple: "#7C3AED",
  purpleDeep: "#6D28D9",
  katanaTeal: "#4ECDC4",
  purpleTint: "#F5F3FF",
} as const;

/**
 * Create the CCS-branded admin theme.
 *
 * The optional `primaryColor` param is kept for API compatibility but all 3
 * admin portals now use the unified CCS brand palette (katanaPurple).
 * Pass a custom primary only when a non-standard colour is truly required.
 */
export function createAdminTheme(primaryColor: string = CCS_PALETTE.katanaPurple): Theme {
  return createMinimalTheme({
    palette: {
      primary: {
        main: primaryColor,
        dark: CCS_PALETTE.purpleDeep,
        contrastText: "#ffffff",
      },
      secondary: {
        main: CCS_PALETTE.katanaTeal,
        contrastText: "#ffffff",
      },
      background: {
        default: "#F9FAFB",
        paper: "#FFFFFF",
      },
    },
  });
}

export type { Theme };
